import React from 'react';
import { ConfigProvider, Layout } from "antd";
import { Outlet } from "react-router-dom";
import './layout.css'
import Header from './header/header';

function LayoutHome() {

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            darkItemBg: '#006eb5',
            darkSubMenuItemBg: '#006eb5',
            darkItemColor: 'white',
            darkItemSelectedBg: 'rgb(0 0 0 / 22%)'
          },
          Table: {
            headerBg: '#91cbf0;',
            rowHoverBg:'#ededed'
          }
        },
        token: {
          colorPrimary: '#006eb5'
        }
      }
      }
    >
      <Layout style={{backgroundColor:'white'}}>
        <Header />
        <Outlet/>
      </Layout>
    </ConfigProvider>
  )
}

export default React.memo(LayoutHome);